<script lang="ts" setup>
import ResetSearchButton from '@storefront-satch/components/molecules/search/ResetSearchButton.vue'
import SearchButton from '@storefront-satch/components/molecules/search/SearchButton.vue'
import SearchForm from '@storefront-satch/components/molecules/search/SearchForm.vue'

const props = defineProps<{
  query?: string | undefined
  id?: string | undefined
}>()
</script>

<template>
  <SearchForm
    :id="props.id"
    :query="props.query"
  >
    <template #button-before="{ disabled }">
      <SearchButton :disabled="disabled" />
    </template>
    <template #button-after="{ handleClick }">
      <ResetSearchButton :handle-click="handleClick" />
    </template>
  </SearchForm>
</template>
